var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 0.921875C3.53125 0.664062 3.78906 0.5 4.07031 0.5H6.90625C7.1875 0.5 7.44531 0.664062 7.5625 0.921875L7.75 1.25H10C10.3984 1.25 10.75 1.60156 10.75 2C10.75 2.42188 10.3984 2.75 10 2.75H1C0.578125 2.75 0.25 2.42188 0.25 2C0.25 1.60156 0.578125 1.25 1 1.25H3.25L3.41406 0.921875ZM0.976562 3.5H10V11C10 11.8438 9.32031 12.5 8.5 12.5H2.47656C1.65625 12.5 0.976562 11.8438 0.976562 11V3.5ZM2.85156 5.375V10.625C2.85156 10.8359 3.03906 11 3.22656 11C3.4375 11 3.60156 10.8359 3.60156 10.625V5.375C3.60156 5.1875 3.4375 5 3.22656 5C3.03906 5 2.85156 5.1875 2.85156 5.375ZM5.10156 5.375V10.625C5.10156 10.8359 5.28906 11 5.47656 11C5.6875 11 5.875 10.8359 5.875 10.625V5.375C5.875 5.1875 5.6875 5 5.47656 5C5.28906 5 5.10156 5.1875 5.10156 5.375ZM7.375 5.375V10.625C7.375 10.8359 7.53906 11 7.75 11C7.9375 11 8.125 10.8359 8.125 10.625V5.375C8.125 5.1875 7.9375 5 7.75 5C7.53906 5 7.375 5.1875 7.375 5.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteKe);
export default __webpack_public_path__ + "static/media/IconDelete_KE.f0a09c69724fca10bf10a0db62b61f64.svg";
export { ForwardRef as ReactComponent };